import { FinanceDataDisplayModelFormGroup } from './../../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/finance-data-display-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DocumentDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { StateService } from '@/core/services/state.service';
import { DocumenttypeDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model';
import { SectionService } from '@/core/services/section.service';
import { GlobalEnumsAceFormulartyp } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-formulartyp';
import { PortalContextService } from '@/core/services/portal-context.service';
import { financeFoerdersummeValidator } from '@/core/validators/customform.validators';
import { GlobalEnumsAceBerechnungsmethode } from '@/api/model-index';
import { GlobalEnumsAceAntragstellungerfolgtfuer } from '../../../../../../api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-antragstellungerfolgtfuer';
import { Constants } from '@/constants';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';

@Component({
  selector: 'finance-data',
  templateUrl: './finance-data.component.html',
  styleUrls: ['./finance-data.component.scss']
})
export class FinanceDataComponent implements OnInit {
  public subscriptions: Subscription[] = [];

  @Input("form") public financeDataForm: FinanceDataDisplayModelFormGroup;
  @Input() showimport: boolean = false;
  @Input() finanzplanDocumentId: string;

  @Output('documentUploaded') documentUploadedEventEmitter: EventEmitter<DocumentDisplayModel> = new EventEmitter<DocumentDisplayModel>();

  public financeDataDisplayForm: UntypedFormGroup = new UntypedFormGroup({
    gesamt: new UntypedFormControl({value: null}, []),
    foerdersumme: new UntypedFormControl({value: null}, []),
  });

  public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;
  
  public get documentType(): DocumenttypeDisplayModel | null {
    if (this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.documenttypes) {
      let docType = this.portalContextService.CurrentAnfrage.documenttypes.filter(documenttyp => documenttyp.sectionId == this.sectionService.current()?.id)[0];
      return docType;
    }
    return null;
  }

  public get gesamtFormControl(): AbstractControl {
    return this.financeDataDisplayForm.controls["gesamt"];
  }

  public get antragstellungFuerInstitution(): boolean{
    if(this.financeDataForm.Antragstellungerfolgtfuer.value != GlobalEnumsAceAntragstellungerfolgtfuer.Kontakt){
      this.financeDataForm.Antragstellungerfolgtfuer.setValue(GlobalEnumsAceAntragstellungerfolgtfuer.Institution)
      return true;
      
    }
    else
      return false;
  }

  constructor(protected portalContextService: PortalContextService, protected sectionService: SectionService, protected stateService: StateService) {
  }

  ngOnInit(): void {
    this.gesamtFormControl.setValue(this.gesamt);

    if (this.showimport) {
      this.financeDataForm.controls["personalmittel"].disable();
      this.financeDataForm.controls["sachmittel"].disable();
      this.financeDataForm.controls["investitionsmittel"].disable();
      this.financeDataForm.controls["eigenmittel"].disable();
      this.financeDataForm.controls["drittmittel"].disable();
    }

    this.financeDataForm.Drittmittel.addValidators([Validators.min(0)]);
    this.financeDataForm.Personalmittel.addValidators([Validators.min(0)]);
    this.financeDataForm.Sachmittel.addValidators([Validators.min(0)]);
    this.financeDataForm.Eigenmittel.addValidators([Validators.min(0)]);
    this.financeDataForm.Drittmittel.addValidators([Validators.min(0)]);
    this.financeDataForm.Investitionsmittel.addValidators([Validators.min(0)]);

    this.subscriptions.push(
      this.financeDataForm.valueChanges.subscribe(value => {
        this.gesamtFormControl.setValue(this.gesamt);
        if (this.isFoerdersummeDisabled) {
          this.financeDataForm.Foerdersumme.setValue(this.foerdersumme, { emitEvent: false });
        }
      })
    )

    if (this.stateService.IsEndvalidationEnabled) {
      this.financeDataForm.Foerdersumme.addValidators(financeFoerdersummeValidator);
      this.financeDataDisplayForm.markAllAsTouched();
    }

    Array.from(document.getElementsByClassName('k-input-inner') as HTMLCollectionOf<HTMLElement>).forEach(input => {
      input.style.textAlign = "right";
    })
    
  }

  get berechnungsmethode() {
    // Cast von Enum auf any für Check ob Enum 0 ist
    if (this.sectionService.current()?.berechnungsmethode as any != 0)
      return this.sectionService.current()?.berechnungsmethode;

    return this.financeDataForm.Berechnungsmethode.value;
  }

  get reverseCalculationRow() {
    return this.berechnungsmethode == GlobalEnumsAceBerechnungsmethode.Gesamtprojektsumme;
  }

  public getFieldLabelByBerechnungsmethode(label: string): string {
    if(GlobalEnumsAceBerechnungsmethode.Gesamtprojektsumme == this.berechnungsmethode) {
      if(label == 'finance-data.equitycapital')
        return 'finance-data.equitycapital.gesamtprojektsumme';
      if (label == 'finance-data.thirdPartyFunds')
        return 'finance-data.thirdPartyFunds.gesamtprojektsumme';
      
    }

    return label;
  }

  public get foerdersumme(): number {
    if (this.berechnungsmethode == GlobalEnumsAceBerechnungsmethode.Fordersumme) {
      let personalmittel: number = this.financeDataForm.Personalmittel.value != null ? this.financeDataForm.Personalmittel.value : 0;
      let sachmittel: number = this.financeDataForm.Sachmittel.value != null ? this.financeDataForm.Sachmittel.value : 0;
      let investitionsmittel: number = this.financeDataForm.Investitionsmittel.value != null ? this.financeDataForm.Investitionsmittel.value : 0;
      return personalmittel + sachmittel + investitionsmittel;
    }
    else if (this.berechnungsmethode == GlobalEnumsAceBerechnungsmethode.Gesamtprojektsumme) {
      let eigenmittel: number = this.financeDataForm.Eigenmittel.value != null ? this.financeDataForm.Eigenmittel.value : 0;
      let drittmittel: number = this.financeDataForm.Drittmittel.value != null ? this.financeDataForm.Drittmittel.value : 0;
  
      return this.gesamt - (eigenmittel + drittmittel);
    }

    return 0;
  }

  public get gesamt(): number {
    if (this.berechnungsmethode == GlobalEnumsAceBerechnungsmethode.Fordersumme) {
      let eigenmittel: number = this.financeDataForm.Eigenmittel.value != null ? this.financeDataForm.Eigenmittel.value : 0;
      let drittmittel: number = this.financeDataForm.Drittmittel.value != null ? this.financeDataForm.Drittmittel.value : 0;
  
      return this.foerdersumme + eigenmittel + drittmittel;
    }
    else if (this.berechnungsmethode == GlobalEnumsAceBerechnungsmethode.Gesamtprojektsumme) {
      let personalmittel: number = this.financeDataForm.Personalmittel.value != null ? this.financeDataForm.Personalmittel.value : 0;
      let sachmittel: number = this.financeDataForm.Sachmittel.value != null ? this.financeDataForm.Sachmittel.value : 0;
      let investitionsmittel: number = this.financeDataForm.Investitionsmittel.value != null ? this.financeDataForm.Investitionsmittel.value : 0;
      return personalmittel + sachmittel + investitionsmittel;
    }

    return 0;
  }

  public get isFoerdersummeDisabled(): boolean {
    return this.showimport 
    || this.berechnungsmethode != GlobalEnumsAceBerechnungsmethode.Fordersumme
    || this.financeDataForm.Personalmittel.value
    || this.financeDataForm.Sachmittel.value
    || this.financeDataForm.Investitionsmittel.value;
  }

  public onDocumentUploaded(docModel: DocumentDisplayModel)
  {
    this.documentUploadedEventEmitter.emit(docModel);
  }
}
